import { Guard, type GuardRun } from '../utils/Guard';
import { stateMe } from '$states/me.svelte';

export class AccessCirclesBreakdown extends Guard implements GuardRun {
  run() {
    if (stateMe.onboarding()) {
      return this.cancel();
    }
  }
}
